type IconProps = {
  color?: string;
  backgroundColor?: string;
  size?: number;
  className?: string;
};

export function IconSentRequestForNav({
  className,
}: {
  className?: string;
}) {
  return (
    <IconSentRequest className={className} color="currentColor" size={20} />
  );
}

export function IconSentRequest({
  color = "#3D3935",
  backgroundColor,
  size = 26,
  className,
}: IconProps) {
  const bgColor = backgroundColor || color;

  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M15.5983 1.52603C14.8823 1.29341 14.1111 1.29341 13.3952 1.52603C12.9384 1.67446 12.5514 1.9361 12.1619 2.26672C11.7854 2.58631 11.3571 3.01468 10.8326 3.53916L3.53916 10.8326C3.01468 11.3571 2.58631 11.7854 2.26672 12.1619C1.9361 12.5514 1.67446 12.9384 1.52603 13.3952C1.29341 14.1111 1.29341 14.8823 1.52603 15.5983C1.67446 16.0551 1.9361 16.4421 2.26672 16.8316C2.5863 17.208 3.01466 17.6364 3.53912 18.1608L7.83866 22.4603C8.36314 22.9848 8.79152 23.4132 9.16798 23.7328C9.55744 24.0634 9.94446 24.3251 10.4013 24.4735C11.1172 24.7061 11.8884 24.7061 12.6043 24.4735C13.0612 24.3251 13.4482 24.0634 13.8376 23.7328C14.2141 23.4132 14.6425 22.9849 15.167 22.4604L22.4604 15.167C22.9849 14.6425 23.4132 14.2141 23.7328 13.8376C24.0634 13.4482 24.3251 13.0612 24.4735 12.6043C24.7061 11.8884 24.7061 11.1172 24.4735 10.4013C24.3251 9.94445 24.0634 9.55743 23.7328 9.16798C23.4133 8.79155 22.9849 8.36321 22.4605 7.83878L18.1608 3.53912C17.6364 3.01468 17.208 2.58628 16.8316 2.26672C16.4421 1.9361 16.0551 1.67446 15.5983 1.52603Z"
        fill={bgColor}
      />
      <path
        d="M10.8326 3.54304L3.53913 10.8366C3.01467 11.361 2.5863 11.7894 2.26672 12.1658C1.9361 12.5553 1.67446 12.9423 1.52603 13.3991C1.29341 14.115 1.29341 14.8862 1.52603 15.6022C1.72879 16.2262 2.1508 16.7356 2.69132 17.3042C2.87101 17.4932 3.13054 17.5845 3.38901 17.5496L13.3285 16.2064L13.4504 16.19C14.0145 16.1147 14.5142 16.048 14.9293 15.8076C15.292 15.5975 15.5934 15.2962 15.8034 14.9335C16.0439 14.5183 16.1106 14.0187 16.1859 13.4545L16.2022 13.3327L17.5454 3.39272C17.5804 3.13425 17.4891 2.87472 17.3001 2.69502C16.7315 2.15461 16.2222 1.73267 15.5983 1.52994C14.8823 1.29731 14.1111 1.29731 13.3952 1.52993C12.9384 1.67837 12.5514 1.94001 12.1619 2.27063C11.7855 2.59021 11.3571 3.01857 10.8326 3.54304Z"
        fill={color}
      />
      <path
        d="M22.4793 23.8348C22.4793 24.2835 22.1155 24.6473 21.6668 24.6473H2.16679C1.71806 24.6473 1.35429 24.2835 1.35429 23.8348C1.35429 23.386 1.71806 23.0223 2.16679 23.0223L21.6668 23.0223C22.1155 23.0223 22.4793 23.386 22.4793 23.8348Z"
        fill={color}
      />
    </svg>
  );
}